import { useCanRunPaidActions } from "@/app/(components)/specifics/wrappers/BrandProvider/BrandProvider";
import { useT } from "@/app/translations/useT";
import { UserClientAvatar } from "@/app/types/client-avatar/UserClientAvatar";
import { UStyles } from "@/app/utils/UStyles";
import AvatarDetail from "../../AvatarDetail/AvatarDetail";
import styles from "../Avatars.module.css";
import AvatarCardMenu from "./AvatarCardMenu";
import AvatarFreshnessBadge from "./AvatarFreshnessBadge/AvatarFreshnessBadge";

type Props = {
  avatar: UserClientAvatar;
  lang: string;
  isPlaceholder?: boolean;
  isAnalyzing?: boolean;
  isStale?: boolean;
  onExtract?: (isEnrich: boolean) => void;
};

export default function PrimaryCard(props: Props) {
  const _T = useT();
  const canRunPaidActions = useCanRunPaidActions();
  const { avatar, lang, isPlaceholder, isAnalyzing = false, isStale = false, onExtract } = props;

  const isExtracted = avatar.id !== -1;

  return (
    <div className={UStyles.classNames(styles.primaryCard, isPlaceholder && styles.noHover)}>
      <AvatarDetail
        params={{ lang }}
        avatar={avatar}
        isPlaceholder={isPlaceholder}
        isAnalyzing={isAnalyzing}
        actions={
          isPlaceholder ? undefined : (
            <>
              {isExtracted && canRunPaidActions && (
                <AvatarFreshnessBadge
                  isStale={isStale}
                  onEnrich={onExtract ? () => onExtract(true) : undefined}
                />
              )}
              <AvatarCardMenu params={{ lang }} avatar={avatar} onExtract={onExtract} />
            </>
          )
        }
      />
    </div>
  );
}
